export default __webpack_public_path__ + "static/media/google__token.6f4bba84.png";